import React, { Component } from "react";
import { connect } from "react-redux";
import { FabricControls, FabricProductImage } from "../../imports";
import { setUpFabric } from "../../redux/creators/fabricCreators";
import {
  getProductType,
  changeProductVariant,
} from "../../redux/creators/threekitCreators";
import { setCurrentNode } from "../../redux/reducers/playerSlice";
import { hasFrontAndBack, isApparel } from "../../helpers/productHelpers";
import background from "../../../../config/fabricBackgrounds";
import styled from "styled-components";
import "../../../../css/fabric.css";
import { device } from "../../../../utils/breakPoints";
import productValues from "../../assets/fabricProductValues";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

class FabricPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      frontImages: {},
      backImages: {},
    };
  }

  componentDidMount() {
    this.props.setUpFabric();

    // This is needed for adding the b&w filter on large images
    if (fabric.isWebglSupported()) {
      fabric.textureSize = 65536;
    }

    // Set background images if needed
    if (background) {
      this.setState({
        frontImages: background.front,
        backImages: background.back,
      });
    }
  }

  componentDidUpdate() {
    if (productValues[this.props.productType].config?.background) {
      this.updateBackground();
    }
  }

  updateBackground() {
    const imageKey = this.findBackgroundImage();
    const back = document.getElementById("back");
    const front = document.getElementById("front");

    front.style.backgroundImage =
      "url('" + this.state.frontImages[imageKey] + "')";

    if (back) {
      back.style.backgroundImage =
        "url('" + this.state.backImages[imageKey] + "')";
    }
  }

  findBackgroundImage() {
    // Update mug and apparel by color
    if (this.props.productType == "mug") {
      let color = this.props.selectedProduct.option1 || "White";
      return color.split(" ")[0];
    } else if (isApparel(this.props.productType)) {
      let color = this.props.selectedProduct.option2 || "White";
      return color.split(" ")[0];
      // Update single prints by size
    } else if (
      this.props.productType == "single-canvas" ||
      this.props.productType == "poster" ||
      this.props.productType == "metal"
    ) {
      const { canWidth, canHeight } = this.props.dimensions;
      const size = canHeight > canWidth ? canHeight : canWidth;
      if (size > 0 && size < 21) {
        return "small";
      } else if (size > 20 && size < 41) {
        return "medium";
      } else {
        return "large";
      }
      // Else return default image
    } else {
      return "static";
    }
  }

  toggleCanvas() {
    const back = document.getElementById("back");
    const front = document.getElementById("front");

    const checked = document.getElementById("fabricToggle").checked;
    const side = checked ? "back" : "front";

    if (!checked) {
      back.style.zIndex = "-25";
      front.style.zIndex = "0";
    } else {
      front.style.zIndex = "-25";
      back.style.zIndex = "0";
    }

    this.props.setCurrentNode(side);
  }

  render() {
    return (
      <>
        <EditMessage>
          <FontAwesomeIcon icon={faCircleExclamation} />
          <span>
          Your print(s) will look exactly like the preview(s), move your image
          using the controls below.<br></br>
          This is a self-service platform, we do not retouch any images. Darker photos can tend to be darker on the printed canvas. If you are concerned, use the editing tools on your phone, or an app, and then load that new lightened version of your image.
          </span>
        </EditMessage>
        <Container id="fabricPlayerContainer">
          {hasFrontAndBack(this.props.productType) && (
            <div className="switch-button-container">
              <div className="switch-button">
                <input
                  id="fabricToggle"
                  className="switch-button-checkbox"
                  type="checkbox"
                  onChange={() => this.toggleCanvas()}
                ></input>
                <label className="switch-button-label">
                  <span className="switch-button-label-span">Front</span>
                </label>
              </div>
            </div>
          )}

          <div id="fabricPlayer" className="fabricPlayer-container">
            <div id="front">
              <canvas id="frame" />
              <canvas id="canvas" />
              <FabricProductImage side="front" />
            </div>

            {hasFrontAndBack(this.props.productType) && (
              <div id="back">
                <canvas id="canvasBack" />
                <FabricProductImage side="back" />
              </div>
            )}
          </div>
        </Container>
        <FabricControls />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  productType: getProductType(state),
  selectedProduct: state.threekit.selectedProduct,
  dimensions: state.playerState.dimensions,
  nodes: state.fabric.nodes,
});
export default connect(mapStateToProps, {
  setUpFabric,
  setCurrentNode,
  changeProductVariant,
})(FabricPlayer);

const EditMessage = styled.div`
  padding: 10px;
  width: 100%;
  font-weight: bold;
  color: #000000;
  border-radius: 0.25rem;
  border: 1px solid black;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  gap: 0.75rem;
  align-items: center;
  @media ${device.tablet} {
    margin-top: 10px;
  }
`;
const Container = styled.div`
  background: #f8f4f4;
  padding-top: 10px;
  @media ${device.tablet} {
    padding-left: 0;
    padding-right: 0;
  }
`;
